import styled from "styled-components";

const GameInfoListList = styled.li`
  list-style-type: none;
  margin-left: 2%;
`;

export default GameInfoListList;
